<form *ngIf="cardForm" class="form-horizontal form-material" [formGroup]="cardForm" #formDir="ngForm">

    <!-- Nombre del titular -->
    <div class="row">
        <div class="col-12 form-group" [ngClass]="{'has-danger': invalidCardName}">
            <label class="font-l1">Nombre y apellido</label>
            <input class="form-control" formControlName="cardName" placeholder="Nombre y apellido">
            <small class="form-control-feedback" *ngIf="invalidCardName">
                El nombre completo es requerido
            </small>
        </div>
    </div>

    <!-- Tarjeta con Stripe: los campos son iframes, el número nunca pasa por
         nuestro DOM ni por el backend -->
    <app-stripe-card *ngIf="isStripe" [isDarkMode]="isDarkMode"
        [cardholderName]="cardName?.value" (completeChange)="onStripeCardComplete($event)">
    </app-stripe-card>

    <!-- Número de tarjeta (ONVO) -->
    <div class="row" *ngIf="!isStripe">
        <div class="col-12 form-group" [ngClass]="{'has-danger': invalidNumber}">
            <label class="font-l1">Número de tarjeta</label>
            <input class="form-control" mask="0000 0000 0000 0000" formControlName="number"
                placeholder="Número de tarjeta" (keyup)="onChangeCardNumber($event)">
            <small class="form-control-feedback" *ngIf="invalidNumber">
                <span *ngIf="number.errors?.required">El número de tarjeta es requerido</span>
                <span *ngIf="number.errors?.pattern">El número de tarjeta debe ser válido</span>
            </small>
        </div>
    </div>

    <!-- Expiración / CVC (ONVO) -->
    <div class="row" *ngIf="!isStripe">
        <div class="form-group col-7" [ngClass]="{'has-danger': invalidExpiry}">
            <label class="font-l1">Fecha expiración</label>
            <input class="form-control" numeric numericType="expiry" formControlName="expiry"
                placeholder="MM/YY" (keydown)="onChangeCardExpiry($event)">
            <small class="form-control-feedback" *ngIf="invalidExpiry">
                <span *ngIf="expiry.errors?.required">La fecha de expiración es requerida</span>
                <span *ngIf="expiry.errors?.pattern">La fecha de expiración debe ser válida.</span>
            </small>
        </div>

        <div class="form-group col-5" [ngClass]="{'has-danger': invalidCvc}">
            <label class="font-l1">CVC</label>
            <input class="form-control" numeric [mask]="dynamicMask" formControlName="cvc"
                placeholder="CVC" (keyup)="onChangeCVC($event)">
            <small class="form-control-feedback" *ngIf="invalidCvc">
                El CVC es requerido
            </small>
        </div>
    </div>

    <div class="form-check d-flex align-items-center" *ngIf="showSaveCard" style="padding-left: 0px !important;">
        <input type="checkbox" class="form-check-input tiny-checkbox" formControlName="allowSavingCard">
        <div class="m-l-30 font-10 d-flex align-items-center">
            Guardar información para futuras compras
        </div>
    </div>
</form>
